var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "添加文档",
            visible: _vm.dialog,
            modal: false,
            "close-on-click-modal": false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialog = $event
            },
            close: function($event) {
              return _vm.resetForm("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "title", label: "标题" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.paramsData.title,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "title", $$v)
                      },
                      expression: "paramsData.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "kind", label: "类型" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择类型", clearable: "" },
                      model: {
                        value: _vm.paramsData.kind,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "kind", $$v)
                        },
                        expression: "paramsData.kind"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "table_description",
                          value: "table_description"
                        }
                      }),
                      _c("el-option", {
                        attrs: { label: "field_alias", value: "field_alias" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "entity_mapping",
                          value: "entity_mapping"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "ownership_doc",
                          value: "ownership_doc"
                        }
                      }),
                      _c("el-option", {
                        attrs: { label: "fixed_filter", value: "fixed_filter" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "metric_definition",
                          value: "metric_definition"
                        }
                      }),
                      _c("el-option", {
                        attrs: { label: "example_sql", value: "example_sql" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "global_policy",
                          value: "global_policy"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "metric_policy",
                          value: "metric_policy"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "data_model_policy",
                          value: "data_model_policy"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "feedback_note",
                          value: "feedback_note"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "version", label: "版本" }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: "请输入，如 v1" },
                    model: {
                      value: _vm.paramsData.version,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "version", $$v)
                      },
                      expression: "paramsData.version"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "priority", label: "优先级" }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, "controls-position": "right" },
                    model: {
                      value: _vm.paramsData.priority,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "priority", $$v)
                      },
                      expression: "paramsData.priority"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "enabled", label: "状态" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.paramsData.enabled,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "enabled", $$v)
                        },
                        expression: "paramsData.enabled"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "disabled 草案", value: "false" }
                      }),
                      _c("el-option", {
                        attrs: { label: "enabled", value: "true" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "document_type", label: "文档用途" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "未指定", clearable: "" },
                      model: {
                        value: _vm.paramsData.document_type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "document_type", $$v)
                        },
                        expression: "paramsData.document_type"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Schema 配置", value: "schema_config" }
                      }),
                      _c("el-option", {
                        attrs: { label: "关联文档", value: "related_doc" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "字段映射明细",
                          value: "field_mapping_detail"
                        }
                      }),
                      _c("el-option", {
                        attrs: { label: "归属文档", value: "ownership_doc" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "归属/属性文档",
                          value: "entity_attribute_doc"
                        }
                      }),
                      _c("el-option", {
                        attrs: { label: "业务规则", value: "business_policy" }
                      }),
                      _c("el-option", {
                        attrs: { label: "示例 SQL", value: "example_sql_doc" }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "反馈候选",
                          value: "feedback_candidate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "table_name", label: "表" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入表名" },
                    model: {
                      value: _vm.paramsData.table_name,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "table_name", $$v)
                      },
                      expression: "paramsData.table_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "column_name", label: "字段" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入字段名" },
                    model: {
                      value: _vm.paramsData.column_name,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "column_name", $$v)
                      },
                      expression: "paramsData.column_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "keywords", label: "关键词" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "多个英文逗号分隔" },
                    model: {
                      value: _vm.paramsData.keywords,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "keywords", $$v)
                      },
                      expression: "paramsData.keywords"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "tags", label: "标签" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "多个英文逗号分隔" },
                    model: {
                      value: _vm.paramsData.tags,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "tags", $$v)
                      },
                      expression: "paramsData.tags"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "relation_type", label: "关系类型" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "maps_field / belongs_to / joins_with"
                    },
                    model: {
                      value: _vm.paramsData.relation_type,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "relation_type", $$v)
                      },
                      expression: "paramsData.relation_type"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "schema_linking_focus", label: "Schema 聚焦" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "自动判断", clearable: "" },
                      model: {
                        value: _vm.paramsData.schema_linking_focus,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "schema_linking_focus", $$v)
                        },
                        expression: "paramsData.schema_linking_focus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "自动判断", value: "" }
                      }),
                      _c("el-option", {
                        attrs: { label: "强制参与", value: "true" }
                      }),
                      _c("el-option", {
                        attrs: { label: "显式禁用", value: "false" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "related_tables", label: "关联表" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "多个英文逗号分隔" },
                    model: {
                      value: _vm.paramsData.related_tables,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "related_tables", $$v)
                      },
                      expression: "paramsData.related_tables"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "related_columns", label: "关联字段" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "多个英文逗号分隔" },
                    model: {
                      value: _vm.paramsData.related_columns,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "related_columns", $$v)
                      },
                      expression: "paramsData.related_columns"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "context_columns", label: "Context 字段" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如 event_date, role_id" },
                    model: {
                      value: _vm.paramsData.context_columns,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "context_columns", $$v)
                      },
                      expression: "paramsData.context_columns"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "generator_context_max_chars",
                    label: "Generator正文上限"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "如 400，0表示使用全局预算",
                      type: "number"
                    },
                    model: {
                      value: _vm.paramsData.generator_context_max_chars,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paramsData,
                          "generator_context_max_chars",
                          _vm._n($$v)
                        )
                      },
                      expression: "paramsData.generator_context_max_chars"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "generator_summary", label: "Generator 摘要" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "用于 SQLGEN 的短摘要，必须保留关键约束"
                    },
                    model: {
                      value: _vm.paramsData.generator_summary,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "generator_summary", $$v)
                      },
                      expression: "paramsData.generator_summary"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "metadata", label: "Metadata JSON" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder:
                        '标准 JSON 格式：{"generator_summary":"短摘要","context_columns":["role_id"]}'
                    },
                    model: {
                      value: _vm.paramsData.metadata,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "metadata", $$v)
                      },
                      expression: "paramsData.metadata"
                    }
                  })
                ],
                1
              ),
              _c("hr", { staticClass: "form-divider" }),
              _c(
                "el-form-item",
                {
                  staticClass: "type-selector-item",
                  attrs: { prop: "type", label: "上传类型" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleTypeChange },
                      model: {
                        value: _vm.paramsData.type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "type", $$v)
                        },
                        expression: "paramsData.type"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "text" } }, [
                        _vm._v("文本内容")
                      ]),
                      _c("el-radio-button", { attrs: { label: "upload" } }, [
                        _vm._v("文件上传")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticStyle: { width: "100%" } }),
              _vm.paramsData.type === "text"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "content", label: "文本内容" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入具体的文档内容"
                        },
                        model: {
                          value: _vm.paramsData.content,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "content", $$v)
                          },
                          expression: "paramsData.content"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type === "upload"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "file", label: "文件上传" }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "#",
                            "auto-upload": false,
                            "on-change": _vm.handleFileChange,
                            "on-remove": _vm.handleFileRemove,
                            "file-list": _vm.fileList,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            accept: ".txt"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [_vm._v(" 支持扩展名：.txt, 单文件最大 50MB ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("提交保存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }